export default __webpack_public_path__ + "static/media/fsplus-idea.782e9961.png";